import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { FormBase } from 'src/app/_models/form-base';

@Component({
  selector: 'app-slide-toggle-group',
  imports: [MatButtonToggleGroup, MatButtonToggle, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './slide-toggle-group.component.html',
  styleUrls: ['./slide-toggle-group.component.scss'],
})
export class SlideToggleGroupComponent {
  /** Field form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Allow multiple selection */
  allowMultipleSelection = input<boolean>(false);

  /** Toggle clicked output */
  toggleClicked = output<string | number>();

  onToggleClick(event: string | number): void {
    this.toggleClicked.emit(event);
  }
}
